﻿import './Content.scss';

// Components
import '../Components/Reviews/Reviews.scss';
import '../Components/Reviews/ReviewsCarousel/ReviewsCarousel';
import '../Components/Reputation/ReputationCarousel/ReputationCarousel';
import '../Components/GoogleReviews/GoogleReviewsCarousel/GoogleReviewsCarousel';
import '../Components/Location/Location.scss';
import '../Components/Location/LocationMap/LocationMap';
import '../Components/HighLight/HighLight.scss';
import '../Components/CallForm/CallForm/CallForm';
import '../Components/CallForm/CallForm.scss';

// shared styles
import '../Shared/Form/Inputs/Inputs.scss';


// WEBPACK FOOTER //
// ./Src/Content/Content.js